var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player-360"},[_c('video',{ref:"video",staticClass:"video-js vjs-16-9 vjs-default-skin",attrs:{"crossorigin":"anonymous"}},[_c('source',{attrs:{"src":_vm.signedClipUrl,"type":"video/mp4"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }